var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2278 0.191206C10.6694 -0.0637355 11.2135 -0.0637354 11.655 0.191207L20.2182 5.29674C20.6597 5.55168 20.9318 6.02283 20.9318 6.53271V16.3022C20.9318 16.8121 20.6597 17.2833 20.2182 17.5382L11.655 22.6437C11.2135 22.8987 10.6694 22.8987 10.2278 22.6437L1.66476 17.5382C1.22319 17.2833 0.951172 16.8121 0.951172 16.3022V6.53271C0.951172 6.02283 1.22319 5.55168 1.66476 5.29674L10.2278 0.191206ZM16.3462 8.96319C16.7515 8.54518 16.7515 7.86744 16.3462 7.44943C15.9408 7.03142 15.2837 7.03142 14.8783 7.44943L9.38453 13.1149L7.00462 10.6606C6.59928 10.2426 5.94208 10.2426 5.53673 10.6606C5.13139 11.0786 5.13139 11.7563 5.53673 12.1744L8.65059 15.3855C8.84525 15.5863 9.10925 15.699 9.38453 15.699C9.65982 15.699 9.92382 15.5863 10.1185 15.3855L16.3462 8.96319Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/check-white.a837e95d31ea68bc493a1bc51ade4cb1.svg";
export { ForwardRef as ReactComponent };